<!-- src/app/pages/expediente/expediente-digital/sections/paraclinicos/paraclinicos-page/components/tabla-resultados-laboratorio/tabla-resultados-laboratorio.component.html -->

<div class="tabla-container">
  <!-- Header con resumen -->
  <div class="header-resumen">
    <div class="resumen-item">
      <span class="label">Total parámetros:</span>
      <span class="value">{{ resultadosEditables.length }}</span>
    </div>
    <div class="resumen-item resumen-alerta">
      <span class="label">Fuera de rango:</span>
      <span class="value">{{ getCountFueraRango() }}</span>
    </div>
    <div class="resumen-item">
      <span class="label">Confianza promedio:</span>
      <span class="value">{{ getConfianzaPromedio() }}%</span>
    </div>
  </div>

  <!-- Tabla de resultados -->
  <div class="tabla-scroll">
    <table class="tabla-resultados">
      <thead>
        <tr>
          <th>Parámetro</th>
          <th>Valor</th>
          <th>Unidad</th>
          <th>Rango Normal</th>
          <th>Estado</th>
          <th>Confianza</th>
          <th *ngIf="editable">Texto Original</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let resultado of resultadosEditables; let i = index" [class]="getFilaClass(resultado)">
          <!-- Parámetro -->
          <td class="parametro-cell">
            <div class="font-semibold">{{ resultado.parametroNombre }}</div>
          </td>

          <!-- Valor (editable) -->
          <td class="valor-cell">
            <input
              *ngIf="editable"
              type="number"
              [(ngModel)]="resultado.valor"
              (ngModelChange)="onValorChange(resultado)"
              class="input-valor"
              step="0.01"
            />
            <span *ngIf="!editable">{{ resultado.valor }}</span>
          </td>

          <!-- Unidad -->
          <td class="unidad-cell">
            {{ resultado.unidad }}
          </td>

          <!-- Rango Normal -->
          <td class="rango-cell">
            {{ getRangoNormal(resultado) }}
          </td>

          <!-- Estado -->
          <td class="estado-cell">
            <span [class]="getEstadoClass(resultado)">
              {{ getEstadoTexto(resultado) }}
            </span>
          </td>

          <!-- Confianza -->
          <td class="confianza-cell">
            <div class="flex items-center gap-2">
              <div class="progress-bar">
                <div
                  class="progress-fill"
                  [style.width.%]="(resultado.confianza || 0) * 100"
                  [class.progress-high]="(resultado.confianza || 0) >= 0.8"
                  [class.progress-medium]="(resultado.confianza || 0) >= 0.6 && (resultado.confianza || 0) < 0.8"
                  [class.progress-low]="(resultado.confianza || 0) < 0.6"
                ></div>
              </div>
              <span class="text-xs">{{ ((resultado.confianza || 0) * 100).toFixed(0) }}%</span>
            </div>
          </td>

          <!-- Texto Original -->
          <td *ngIf="editable" class="texto-original-cell">
            <span class="text-xs text-gray-500">{{ resultado.textoOriginal }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Footer con botones -->
  <div class="footer-actions" *ngIf="editable">
    <ion-button fill="outline" color="medium" (click)="onCancelar()"> Cancelar </ion-button>
    <ion-button color="primary" (click)="onGuardar()"> Guardar {{ resultadosEditables.length }} Resultados </ion-button>
  </div>
</div>
